var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var MainImg = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: calc(250px + 2rem);\n  width: calc(250px + 2rem);\n  margin-bottom: 0.5rem;\n  object-fit: cover;\n"], ["\n  height: calc(250px + 2rem);\n  width: calc(250px + 2rem);\n  margin-bottom: 0.5rem;\n  object-fit: cover;\n"])));
export var MainImage = function (_a) {
    var src = _a.src;
    return React.createElement(MainImg, { src: src });
};
var templateObject_1;
